import React, { useState, useRef, useEffect } from 'react';
import { MdMenu, MdLightMode, MdDarkMode, MdLogout } from 'react-icons/md';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

const TopBar = ({ onToggleSidebar }) => {
  const { theme, toggleTheme } = useTheme();
  const { user, logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const initials = user?.username ? user.username.charAt(0).toUpperCase() : 'U';

  return (
    <div className="sticky top-0 z-30 bg-white dark:bg-surface-dark border-b border-gray-200 dark:border-gray-800 px-4 py-2.5 flex items-center">
      {/* Mobile only — sidebar toggle (desktop uses sidebar's own hamburger) */}
      <button
        className="lg:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-500 dark:text-gray-400"
        onClick={onToggleSidebar}
        aria-label="Open sidebar"
      >
        <MdMenu size={22} />
      </button>

      <div className="flex-1" />

      {/* Right actions */}
      <div className="flex items-center gap-1">
        <button
          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-500 dark:text-gray-400"
          onClick={toggleTheme}
          aria-label="Toggle theme"
        >
          {theme === 'light' ? <MdDarkMode size={18} /> : <MdLightMode size={18} />}
        </button>

        <div className="relative" ref={dropdownRef}>
          <button
            className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300 flex items-center justify-center text-xs font-semibold hover:bg-gray-300 dark:hover:bg-gray-600"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            {initials}
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-1 w-48 bg-white dark:bg-surface-dark border border-gray-200 dark:border-gray-800 rounded-lg shadow-lg py-1 z-50">
              <div className="px-3 py-2 text-sm font-medium text-gray-800 dark:text-gray-200">
                {user?.username}
              </div>
              <div className="border-t border-gray-200 dark:border-gray-800 my-1" />
              <button
                className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center gap-2"
                onClick={() => { logout(); setDropdownOpen(false); }}
              >
                <MdLogout size={16} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
